import api from '../api/client';

/**
 * Creates a PayMongo checkout session for the provided order.
 * Returns the hosted checkout URL that the customer should be redirected to.
 */
export const createPaymongoCheckoutSession = async ({
  orderId,
  amount,
  description,
  remarks,
  token,
  metadata = {},
  successPath,
  cancelPath
}) => {
  if (!orderId || !amount) {
    throw new Error('Missing required PayMongo checkout parameters.');
  }

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const successUrl = successPath
    ? `${origin}${successPath}`
    : `${origin}/order-confirmation/${orderId}?payment=success`;
  const cancelUrl = cancelPath
    ? `${origin}${cancelPath}`
    : `${origin}/order-confirmation/${orderId}?payment=cancelled`;

  const payload = {
    amount: Number(amount),
    description,
    remarks,
    success_url: successUrl,
    cancel_url: cancelUrl,
    metadata: {
      orderId,
      ...metadata
    }
  };

  const config = token
    ? {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    : undefined;

  const response = await api.post('/payments/create-link', payload, config);
  const checkoutUrl = response.data?.checkoutUrl;

  if (!checkoutUrl) {
    throw new Error('PayMongo checkout URL was not returned by the server.');
  }

  return checkoutUrl;
};


